import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';
import { TabletButton } from '@campfire/tablet-button';

interface DeleteSubmissionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteSubmissionDialog: React.FC<DeleteSubmissionDialogProps> = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>Delete Submission</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to delete this submission? This action cannot be undone.</Typography>
      </DialogContent>
      <DialogActions>
        <TabletButton onClick={onClose}>Cancel</TabletButton>
        <TabletButton onClick={onConfirm} variant='outlined' color='error'>
          Delete
        </TabletButton>
      </DialogActions>
    </Dialog>
  );
};
